module.exports = __webpack_public_path__ + "img/AE5006-P31.696d457d.jpg";